/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useDispatch, useSelector } from 'react-redux';
import { CustomStack, CustomToggleSwitch } from 'modules/common/components';
import { Typography } from '@mui/material';
import { selectForecastDisabledText, selectsHotelForecast } from '../../../../../selectors';
/**
 * Lag aligned window component common for the dashboard component
 * @param {Boolean} paceLagAligned - State of Lag Aligned toggle
 * @param {*} paceCumulative - State of Cumulative toggle
 * @returns
 */
const LagAlignedWindow = ({
  paceLagAligned,
  paceCumulative,
  changePaceLagAligned,
  changePaceCumulative,
  isPaceForecast,
  IsForecastDisabled,
  setIsPaceForecast,
}) => {
  const dispatch = useDispatch();
  const isHotelForecast = useSelector(selectsHotelForecast);
  const ForecastDisabledText = useSelector(selectForecastDisabledText);
  //
  return (
    <CustomStack>
      <CustomToggleSwitch
        label="Cumulative View"
        title="Change ‘Total Occupied Rooms’ and ‘Total Revenue’ graphs to display the cumulated booking pace for each statistic."
        onChange={(event) => dispatch(changePaceCumulative(event.target.checked))}
        checked={paceCumulative ?? false}
        className= "cumulative-toggle"
      />
      <CustomToggleSwitch
        id="auto-toggle-lag-aligned"
        label="Lag Aligned"
        title="Display the pace-time and pace-segment statistics considering lead time to stay date as opposed to the absolute booking date"
        onChange={(event) => dispatch(changePaceLagAligned(event.target.checked))}
        checked={paceLagAligned ?? false}
        className="lag-aligned-toggle"
      />
      <CustomToggleSwitch
        label="Forecasts"
        title="Enable forecasts on the ‘Total Revenue’ and ‘Total Occupied Rooms’ graphs"
        onChange={(event) => dispatch(setIsPaceForecast(event.target.checked))}
        checked={isPaceForecast ?? false}
        disabled={IsForecastDisabled || !isHotelForecast}
        className ="forecast-toggle"
      />
      {!isHotelForecast && (
        <Typography sx={{ fontSize: 11.5, color: 'gray' }}>{ForecastDisabledText}</Typography>
      )}
    </CustomStack>
  );
};
//
export default LagAlignedWindow;
